import { axios } from "./config.js";
import type {
	TAuthVerifyCreate,
	TAuthVerifyResend,
	TAxiosGenRes,
	TBasicType,
	TForgotPass,
	TGetDriverLocations,
	TGetDrivers,
	TLoginParam,
	TLoginRes,
	TResetPass,
} from "./types";

export default {
	// Auth
	authLogin: (params: TLoginParam) =>
		axios.post<TLoginRes>("admin/login", params),
	authRegister: (params: any) =>
		axios.post<TAxiosGenRes<TBasicType>>("auth/register", params),
	authRenewSession: () =>
		axios.post<{ data: { data: string } }>("admin/checkSid"),
	authLogout: () => axios.get("admin/logout", { validateStatus: null }),
	authVerifyCreate: (params: TAuthVerifyCreate) =>
		axios.post<TLoginRes>("auth/verify", params),
	authVerifyResend: (params: TAuthVerifyResend) =>
		axios.put("auth/verify", params),
	authForgot: (params: TForgotPass) =>
		axios.post("auth/forgot-password", params),
	authResetPass: (params: TResetPass) =>
		axios.put("auth/forgot-password", params),
	getDrivers: (params: TGetDrivers) => axios.get("admin/taxi", { params }),

	getDriverLocations: (params: TGetDriverLocations) =>
		axios.get("admin/get-driver-locations", { params }),
	getDriverInfo: (params: { tax_id: number }) =>
		axios.get("admin/taxi/" + params.tax_id),
	editDriver: (params: any) => axios.put("admin/taxi/" + params.tax_id, params),
	editDriverDetails: (tax_id: number, formData: FormData) =>
		axios.put("admin/taxi/" + tax_id, formData),
	banDriver: (tax_id: number) => axios.delete("admin/taxi/" + tax_id),
	getStatisticsQuick: () => axios.get("admin/statistics/quick"),
	getDriverStatistics: (tax_id: number) =>
		axios.get("admin/taxi/" + tax_id + "/statistics"),
	downloadDocument: (file_id: number) =>
		axios.get("admin/document/" + file_id, { responseType: "blob" }),
	getRides: (params: TGetDrivers) => axios.get("admin/rides", { params }),
	getRideInfo: (rid_id: number) => axios.get("admin/rides/" + rid_id),

	//subscriptions

	getSubscription: (tax_id: number) =>
		axios.get("admin/subscriptions", { params: { tax_id } }),
	deleteSubscription: (sub_id: number) =>
		axios.delete(`admin/subscriptions/${sub_id}`, {
			params: { sub_id },
		}),

	addSubscription: (payload: {
		tax_id: number;
		sub_start_time: string;
		sub_end_time: string;
	}) => axios.post("admin/subscriptions", payload),

	getReports: (params: { limit?: number; offset?: number }) =>
		axios.get("admin/ratings", { params }),
	getTodaysReports: () => axios.get("admin/ratings/today"),

	postSeen: (payload: { rav_id: number[] }) =>
		axios.post("admin/ratings/seen", payload),
};
